import DataValue from "../DataValue"

export interface UsageData {
	total?: DataValue
	smsTotal?: DataValue
	voiceTotal?: DataValue

	totalEstimatedForMonth?: DataValue
	smsTotalEstimatedForMonth?: DataValue
	voiceTotalEstimatedForMonth?: DataValue

	totalEstimatedToDate?: DataValue
	smsTotalEstimatedToDate?: DataValue
	voiceTotalEstimatedToDate?: DataValue
}